module.exports = __webpack_public_path__ + "static/media/sad-progress-bar-icon.52e18d80.svg";